import DOMPurify from 'dompurify'


const SAFE_HTML_CONFIG: DOMPurify.Config = {
  ALLOWED_TAGS: [
    'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'small',
    'ul', 'ol', 'li', 'a', 'span', 'div',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'blockquote', 'sup', 'sub', 'img',
    'table', 'thead', 'tbody', 'tr', 'th', 'td','hr'
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'src', 'alt', 'style'],
  ALLOW_DATA_ATTR: false,
  FORCE_BODY: true,
  ALLOWED_CSS_PROPERTIES: [
  // Text and fonts
  'color', 'background-color',
  'font-family', 'font-size', 'font-weight', 'font-style',
  'text-decoration', 'text-align', 'text-transform',
  'line-height', 'letter-spacing', 'word-spacing',
  'text-indent', 'vertical-align',

  // Blocks
  'width', 'height', 'min-width', 'max-width', 'min-height', 'max-height',
  'margin', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left',
  'padding', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left',

  // Borders
  'border', 'border-width', 'border-style', 'border-color',
  'border-radius', 'border-collapse', 'border-spacing',
  'outline',

  // Lists
  'list-style', 'list-style-type', 'list-style-position',

  // Tables
  'caption-side', 'empty-cells', 'table-layout'
],
}

export function useSanitize() {
  const sanitizeHtml = (dirty: string | null | undefined): string => {
    if (!dirty) return ''
    return DOMPurify.sanitize(dirty, SAFE_HTML_CONFIG) as string
  }

  return { sanitizeHtml }
}
